import { Instagram, Facebook, Twitter, Leaf } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#2E3A2F] text-[#F8F5F0] pt-20 pb-10 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#F8F5F0] text-[#2E3A2F]">
                <Leaf className="h-4 w-4" strokeWidth={1.5} />
              </span>
              <span className="font-serif-display text-2xl leading-none tracking-tight">
                Ayurvedauniversal
              </span>
            </div>
            <p className="mt-6 text-[#F8F5F0]/70 max-w-sm leading-relaxed">
              Rooted in Ayurveda. Written for now. A quiet return to health,
              inner peace and lasting well-being.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <Social icon={<Instagram className="h-4 w-4" strokeWidth={1.5} />} testId="social-instagram" />
              <Social icon={<Facebook className="h-4 w-4" strokeWidth={1.5} />} testId="social-facebook" />
              <Social icon={<Twitter className="h-4 w-4" strokeWidth={1.5} />} testId="social-twitter" />
            </div>
          </div>

          <FooterCol title="Explore" links={[
            { label: "Story", href: "#story" },
            { label: "Philosophy", href: "#philosophy" },
            { label: "Remedies", href: "#products" },
            { label: "Voices", href: "#voices" },
          ]} />

          <FooterCol title="Categories" links={[
            { label: "Immunity", href: "#products" },
            { label: "Stress Relief", href: "#products" },
            { label: "Digestive Care", href: "#products" },
            { label: "Skin & Hair", href: "#products" },
          ]} />

          <FooterCol title="Contact" links={[
            { label: "ayurvedauniversal4@gmail.com", href: "mailto:ayurvedauniversal4@gmail.com" },
            { label: "+91 98 3216 5040", href: "tel:+919832165040" },
            { label: "Book Consultation", href: "#contact" },
          ]} />
        </div>

        <div className="mt-16 pt-8 border-t border-[#F8F5F0]/15 flex flex-wrap items-center justify-between gap-4 text-xs text-[#F8F5F0]/60">
          <span>© {new Date().getFullYear()} Ayurvedauniversal. All rights reserved.</span>
          <span className="italic">Wellness beyond relief.</span>
        </div>
      </div>

      {/* Massive brand watermark — spans full footer width */}
      <div
        data-testid="footer-watermark"
        aria-hidden
        className="mt-12 w-full font-serif-display leading-[0.85] tracking-tight text-[#F8F5F0]/10 select-none whitespace-nowrap text-center text-[clamp(3.5rem,13.2vw,15rem)]"
      >
        Ayurvedauniversal
      </div>
    </footer>
  );
}

function Social({ icon, testId }) {
  return (
    <a
      href="#"
      data-testid={testId}
      className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#F8F5F0]/20 hover:bg-[#F8F5F0] hover:text-[#2E3A2F] transition-colors"
    >
      {icon}
    </a>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <div className="overline text-[#F8F5F0]/60">{title}</div>
      <ul className="mt-5 space-y-3">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href}
              className="text-sm text-[#F8F5F0]/85 hover:text-[#E08933] transition-colors"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
